import React, { lazy, Suspense } from "react";
import Landing from "./Landing";
import Navbar from "./navbar/Navbar";
import MobileNav from "./navbar/MobileNav";

// Below-the-fold sections are code-split so the initial chunk only ships the
// hero + navigation. These stream in after first paint.
const Skills = lazy(() => import("./Skills"));
const Portfolio = lazy(() => import("./Portfolio"));
const Contact = lazy(() => import("./Contact"));

function Layout() {
  return (
    <div className="overflow-hidden overflow-x: hidden;" id="mainDom">
      <MobileNav />
      <Navbar />
      <Landing />
      <div className="w-full">
        <main className="flex flex-col items-center w-full" id="skills">
          <Suspense fallback={<div className="min-h-screen" aria-hidden="true" />}>
            <Skills />
            <Portfolio />
            <Contact />
          </Suspense>
        </main>
      </div>
    </div>
  );
}

export default Layout;
